module.exports = __webpack_public_path__ + "static/img/logo-login.05f26a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-login.png
// module id = 756
// module chunks = 0